import { render, staticRenderFns } from "./HousingLanding.vue?vue&type=template&id=74a865d2&scoped=true&"
import script from "./HousingLanding.vue?vue&type=script&lang=js&"
export * from "./HousingLanding.vue?vue&type=script&lang=js&"
import style0 from "./HousingLanding.vue?vue&type=style&index=0&id=74a865d2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74a865d2",
  null
  
)

export default component.exports